import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  NgZone,
  EventEmitter,
  ViewChild,
} from "@angular/core";

import { ModalDirective } from "ngx-bootstrap/modal";

import { Subscription } from "rxjs";

import {
  AuthorizationService,
  Company,
  CompanyService,
  Minesite,
  MinesiteService,
  Equipment,
  EquipmentService,
  MinesiteEquipment,
  MinesiteCompanies,
  MinesiteUsers,
  User,
  ToastrService,
} from "./../../../../shared/index";

@Component({
  selector: "minesite-list",
  templateUrl: "./minesite-list.html",
  standalone: false,
})
export class MinesiteListComponent implements OnInit, OnDestroy {
  @ViewChild("createMinesiteModal") createMinesiteModal: ModalDirective;
  @ViewChild("minesiteDetails") minesiteDetails: ModalDirective;
  @Input() color = "panel-success";
  @Input() live = true;
  @Input("Is_Project_Selected") Is_Project_Selected = false;
  public minesite: Minesite = new Minesite();
  public minesites: Minesite[] = [];
  public equipment: Equipment[] = [];
  public companies: Company[] = [];
  public users: User[] = [];
  public add = true;
  public processing = true;

  private subscriptions: Subscription[] = [];

  constructor(
    private _ngZone: NgZone,
    private _minesiteService: MinesiteService,
    private _toastrService: ToastrService,
    private _equipmentService: EquipmentService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this._minesiteService.minesitesChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          if (this.live) {
            this.minesites = info;
            for (let i = 0; i < info.length; i++) {
              this.minesites[i].Is_Published = true;
            }
          } else {
            this.minesites = info;
            for (let i = 0; i < info.length; i++) {
              this.minesites[i].Is_Published = this.minesites[i].Is_Live;
            }
          }
          this.processing = false;
        });
      })
    );

    this.subscriptions.push(
      this._minesiteService.showEditChange.subscribe((minesite: Minesite) => {
        this._ngZone.run(() => {
          this.add = false;
          this.minesite = minesite;
          this.createMinesiteModal.show();
        });
      })
    );

    this.subscriptions.push(
      this._minesiteService.showDetailChange.subscribe((minesite: Minesite) => {
        this._ngZone.run(() => {
          this.minesite = minesite;
          this.minesiteDetails.show();
        });
      })
    );

    this.subscriptions.push(
      this._minesiteService.minesiteUsersChange.subscribe(
        (minesiteUsers: MinesiteUsers) => {
          this._ngZone.run(() => {
            this.users = minesiteUsers.Users;
          });
        }
      )
    );

    this.subscriptions.push(
      this._minesiteService.minesiteEquipmentChange.subscribe(
        (minesiteEquipment: MinesiteEquipment) => {
          if (this.minesite.Id == minesiteEquipment.MinesiteId) {
            this._ngZone.run(() => {
              if (minesiteEquipment.Reload == true)
                this.equipment.splice(0, this.equipment.length);
              //this.equipment = minesiteEquipment.Equipment;
              minesiteEquipment.Equipment.forEach((e) => {
                this.equipment.push(e);
              });
            });
          }
        }
      )
    );

    this._equipmentService.minesiteEquipmentChange.subscribe(
      (info: MinesiteEquipment) => {
        if (this.live) {
          if (info.MinesiteId == this.minesite.Id) {
            this._ngZone.run(() => {
              if (info.Reload == true)
                this.equipment.splice(0, this.equipment.length);
              info.Equipment.forEach((e) => {
                this.equipment.push(e);
              });
            });
          }
        } else {
          if (info.MinesiteId == this.minesite.Minesite_ID) {
            this._ngZone.run(() => {
              if (info.Reload == true)
                this.equipment.splice(0, this.equipment.length);
              info.Equipment.forEach((e) => {
                this.equipment.push(e);
              });
            });
          }
        }
      }
    );

    this.subscriptions.push(
      this._minesiteService.minesiteCompaniesChange.subscribe(
        (minesiteCompanies: MinesiteCompanies) => {
          if (this.live) {
            if (this.minesite.Id == minesiteCompanies.MinesiteId) {
              this._ngZone.run(() => {
                this.companies = minesiteCompanies.Companies;
              });
            }
          } else {
            if (this.minesite.Minesite_ID == minesiteCompanies.MinesiteId) {
              this._ngZone.run(() => {
                this.companies = minesiteCompanies.Companies;
              });
            }
          }
        }
      )
    );

    this._minesiteService.applyFilter(
      "",
      true,
      true,
      this.live,
      [],
      [],
      [],
      []
    );
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  public close(): void {
    this.minesiteDetails.hide();
  }

  public addMinesite(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    this.add = true;
    this.minesite = new Minesite();
    this.createMinesiteModal.show();
  }

  public cancelAdd(): void {
    this.createMinesiteModal.hide();
    //this._minesiteService.getFilteredMinesites();
    this.minesite = new Minesite();
  }

  public create(another: boolean = false): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    if (this.add) {
      this._minesiteService.create(this.minesite, this.live);
      this.minesite = new Minesite();
      if (!another) {
        this.createMinesiteModal.hide();
      }
      return;
    }

    this._minesiteService.update(this.minesite);
    this.createMinesiteModal.hide();
  }
}
